<template id="app-asset-formats">
  <div id="metadatacontainer">
    <h1>{{ titleText }}</h1>
    <div id="formatList">
      <div v-for="format in formats" :key="format.id" class="formatTile">
        <div>
          {{ displayText(format) }}
          <div>
            {{ format.metadata._author || "Author unknown" }}
          </div>
        </div>
        <div>
          <i
            class="fa fa-folder"
            :class="{ disabled: isReadOnlyGroup }"
            @click="clickExplore(format)"
          ></i>
          <i
            class="fa fa-trash"
            :class="{ disabled: isReadOnlyGroup }"
            @click="clickDelete(format)"
          ></i>
          <i
            class="fa fa-download"
            :class="{ disabled: isReadOnlyGroup }"
            @click="clickDownload(format)"
          ></i>
        </div>
      </div>
      <md-button
        v-if="selectedAsset && selectedAsset.metadata._type === 'Volume'"
        class="md-primary md-raised"
        @click="generateNifti()"
        >Generate Nifti</md-button
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import appSettings from "./appSettings";
import featureToggles from "../enums/FeatureToggles.js";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "AppAssetFormats",
  data: () => ({
    featureToggles: featureToggles,
  }),
  computed: {
    ...mapState([
      "selectedGroup",
      "selectedAsset",
      "allowedFeatureToggles",
      "isMaximized",
    ]),
    ...mapGetters(["isReadOnlyGroup"]),
    formats() {
      if (!this.selectedAsset || !this.selectedAsset.formats) {
        return [];
      }
      const metadata = this.selectedAsset.metadata;
      const outputFormats =
        metadata._type === "Volume"
          ? this.getFormatsOfType(["VOLUME", "NIFTI", "DTI"])
          : [...this.selectedAsset.formats];
      outputFormats.sort(
        (a, b) => new Date(b.metadata._created) - new Date(a.metadata._created)
      );
      return outputFormats;
    },
    titleText() {
      if (!this.selectedAsset) return "";
      const metadata = this.selectedAsset.metadata;
      return metadata._type === "Set"
        ? "Revisions"
        : metadata._type === "Volume"
        ? "Volumes"
        : "Asset Formats";
    },
  },
  watch: {
    "$store.state.isMaximized": function () {
      if (this.isMaximized) {
        this.selectedRevision.value = null;
      }
    },
    "$store.state.selectedAsset": function () {
      this.selectedRevision.value = null;
    },
  },
  methods: {
    ...mapActions(["getAzure", "postAzure"]),
    generateNifti() {
      const url = `${appSettings.remoteurl}/api/groups/${this.selectedGroup.id}/assets/${this.selectedAsset.id}/requestFormat?formatType=VOLUME&maxSize=original&orientation=original&bufferType=niftiFloat`;
      this.getAzure({
        url,
      });
    },
    getFormatsOfType(types) {
      return this.selectedAsset.formats.filter((x) =>
        types.includes(x.metadata._type)
      );
    },
    onFocusOut(event) {
      if (event.srcElement.classList.contains("ellipsis")) return;
      this.selectedEllipsisMenu = null;
    },
    clickDelete(format) {
      this.$emit("deleteformat", format);
      this.selectedEllipsisMenu = null;
    },
    clickDownload(format) {
      this.$emit("downloadformat", format);
      this.selectedEllipsisMenu = null;
    },
    clickExplore(format) {
      this.$emit("exploreformat", format);
    },
    displayText(format) {
      const postfix = format.metadata.displayName
        ? ` (${format.metadata.displayName})`
        : "";
      return format.metadata._type + postfix;
    },
    localTime(date) {
      return date && moment(moment.utc(date).toDate()).format("lll");
    },
  },
};
</script>

<style scoped>
#metadatacontainer {
  background-color: #2d6b7d;
  box-shadow: 3px 3px 20px black;
  border-radius: 10px;
  color: white;
  display: flex;
  margin: 20px 10px;
  align-items: center;
  flex-direction: column;
}
#metadatacontainer h1 {
  font-weight: bold;
}

ul.md-list.md-theme-default {
  background-color: transparent !important;
}

#formatList {
  background: linear-gradient(to left bottom, #5daec7, #3989a1);
  align-self: stretch;
  border-radius: 5px;
  background-color: transparent;
  padding: 7px 12px;
}

#formatList span {
  color: white;
  font-size: 18px;
}

#formatList i {
  padding: 7px;
  color: white;
}

.formatTile {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  padding: 10px 8px;
}
.disabled {
  opacity: 0.5;
}
.fa {
  cursor: pointer;
}

.tile-date {
  font-size: 16px;
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>
